module.exports = __webpack_public_path__ + "static/media/5、砚山县地方政府融资平台资源整合与能力建设综合咨询-min.75b2730d.jpg";